import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hourTwoDigits'
})
export class HourTwoDigitsPipe implements PipeTransform {

  transform(hour: number): string {
    if (!Number.isInteger(hour) || hour < 0 || hour > 23) {
      return '';
    }
    return hour < 10 ? `0${hour}` : hour.toString();
  }

}
